//For dev
// export const hostName = "https://psl-dev-webapp-uksouth-ecb4bcaabsd9gufn.uksouth-01.azurewebsites.net/";

//For Local
//export const hostName = "https://localhost:5001/"

//For Prod
// export const hostName = "https://fds-prod-webapp-uksouth-g6h2gwhxbhcafzc2.uksouth-01.azurewebsites.net/";

// src/api/config.js

// ====== choose ONE base per env ======
// Dev
// const baseHost =
//   "https://psl-dev-webapp-uksouth-ecb4bcaabsd9gufn.uksouth-01.azurewebsites.net";
// Local
// const baseHost = "https://localhost:5001";
// Prod
const baseHost = "https://fds-prod-webapp-uksouth-g6h2gwhxbhcafzc2.uksouth-01.azurewebsites.net";

// pull clientName from /client/:clientName in the current URL
const getClientNameFromPath = () => {
  try {
    const match = window.location.pathname.match(/^\/client\/([^/]+)/i);
    return match?.[1] || "";
  } catch {
    return "";
  }
};

const clientName = getClientNameFromPath();

// If clientName exists, append /Client/{clientName}; else return base
export const hostName = clientName
  ? `${baseHost}/Client/${encodeURIComponent(clientName)}`
  : baseHost;
